const inkeep_ai_bot = {
    intro_message: 'Привет, я Logto AI!\n\nЯ - AI-ассистент, обученный на документации, справочных статьях и другом контенте.\n\nЗадайте мне любой вопрос о `Logto`.',
    chat_placeholder: 'Задайте вопрос Logto AI, чтобы получить пошаговое руководство',
    disclaimer_label: 'Отказ от ответственности Logto AI',
    disclaimer_tooltip: 'Ответы генерируются AI и могут требовать проверки.',
    example_questions_label: 'Примеры вопросов',
    example_questions: [
        'Руководство по быстрому старту для настройки Logto',
        'Настройка архитектуры с несколькими арендаторами',
        'Как интегрировать профиль пользователя?',
    ],
    stop: 'Остановить',
    clear: 'Начать заново',
    get_help: 'Получить помощь',
    copy_chat: 'Копировать',
    ask_ai_label: 'Спросить AI',
    contact: 'Контакт',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
